import { render, staticRenderFns } from "./NumberActions.vue?vue&type=template&id=6348b9da"
import script from "./NumberActions.vue?vue&type=script&lang=js"
export * from "./NumberActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports